// Minimal, privacy‑respecting analytics stub (opt‑in)
// Stores only anonymized, aggregate page view counts in localStorage.

const STORAGE_KEY = 'asmakam.analytics.pageviews';
export const ENABLE_ANALYTICS = true; // toggle to false to disable

type Counts = Record<string, number>;

export function initAnalytics(): void {
	if (!ENABLE_ANALYTICS) return;
	try {
		const existing = localStorage.getItem(STORAGE_KEY);
		if (!existing)
			localStorage.setItem(STORAGE_KEY, JSON.stringify({} satisfies Counts));
	} catch {
		// ignore storage errors
	}
}

export function trackPageView(path: string): void {
	if (!ENABLE_ANALYTICS) return;
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		const data: Counts = raw ? JSON.parse(raw) : {};
		data[path] = (data[path] || 0) + 1;
		localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
	} catch {
		// ignore storage errors
	}
}
